// Domain types for the Admin Lines of Business MSPA. The Rails model is
// `Section`; the v2 API and UI call a root section a "Line of Business" (LOB)
// and a child section a "Service Category".

export interface LineOfBusiness {
  id: string;
  name: string;
  code: string;
  position: number;
}

export interface LobFormValues {
  name: string;
  code: string;
}

export const emptyLobForm: LobFormValues = { name: "", code: "" };

// A row in the deferred Service Categories editor. `clientKey` is a stable id
// for React keys + drag-reorder and is never sent to the server. `id` is the
// server id (null for a row added but not yet saved). `_deleted` marks a
// previously-saved row for deletion on the next Save.
export interface ServiceCategoryRow {
  clientKey: string;
  id: string | null;
  name: string;
  code: string;
  _deleted?: boolean;
}

let keySeq = 0;
export const newServiceCategoryRow = (): ServiceCategoryRow => ({
  clientKey: `new-${keySeq++}`,
  id: null,
  name: "",
  code: "",
});

export const serverCategoryRow = (
  id: string,
  name: string,
  code: string
): ServiceCategoryRow => ({ clientKey: `srv-${id}`, id, name, code });

// A resolved approver row for the Approvers tab.
export interface ServiceApprover {
  id: string; // service-approver record id
  userId: string; // == collaborator id == user id
  name: string; // display name (from the service-approver `name` attribute)
}

export type LobEditTab = "lob" | "approvers";
export const LOB_EDIT_TABS: { key: LobEditTab; label: string }[] = [
  { key: "lob", label: "Line of Business" },
  { key: "approvers", label: "Approvers" },
];
